import React, { useState } from "react";
import "./GameTabs.css";
import { FaClock } from "react-icons/fa";

function GameTabs() {
  const [activeTab, setActiveTab] = useState("30");

  const tabs = [
    { id: "30", label: "30 Sec" },
    { id: "1", label: " 1 Min" },
    { id: "2", label: " 2 Min" },
    { id: "5", label: " 5 Min" },
  ];

  return (
    <div className="game_tabs_parent">
      <div className="game_tabs">
        {tabs.map((tab) => (
          <div
            key={tab.id}
            className={`tab_item ${activeTab === tab.id ? "active" : ""}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <div className="tab_icon">
              <img
                src="/assets/images/icons/clock.png"
                className="clock_img"
                alt="clock"
              />
            </div>
            <p>{tab.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default GameTabs;
